import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'
import SiteExplorer from '../views/SiteExplorer.vue';

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/siteexplorer',
    name: 'Site Explorer',
    component: SiteExplorer
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
